function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import classnames from "classnames";
import useInterval from "client/services/hooks/use-interval";
import PictureComponent from "components/core/picture/picture-component";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_PAGE_CLICKED } from "constants/bigbrain-event-types";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import DefaultProps from "./default-props";
import { StyledReviewsCarousel } from "./reviews-carousel.scss";
const DEFAULT_AUTOPLAY_INTERVAL = 10000; // 10 seconds
export const INDICATOR_WRAPPER_CLASS_NAME = "indicator-wrapper";
const ReviewsCarousel = (props)=>{
    var _reviews_currentReviewIndex;
    const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
    const { autoplay: { shouldAutoPlay, interval }, reviews, removeQuoteSigns } = props;
    useInterval(()=>{
        setCurrentReviewIndex((currentReviewIndex + 1) % reviews.length);
    }, shouldAutoPlay ? Number(interval) || DEFAULT_AUTOPLAY_INTERVAL : null, [
        currentReviewIndex
    ]);
    const selectReview = (reviewIndex, e)=>{
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(`.${INDICATOR_WRAPPER_CLASS_NAME}`)) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        setCurrentReviewIndex(reviewIndex);
        trackEvent(CAROUSEL_PAGE_CLICKED, {
            info1: reviewIndex
        });
    };
    const hasCustomerImage = (review)=>{
        var _review_customerImage;
        return review === null || review === void 0 ? void 0 : (_review_customerImage = review.customerImage) === null || _review_customerImage === void 0 ? void 0 : _review_customerImage.src;
    };
    const hasCompanyLogo = (review)=>{
        var _review_companyLogo;
        return review === null || review === void 0 ? void 0 : (_review_companyLogo = review.companyLogo) === null || _review_companyLogo === void 0 ? void 0 : _review_companyLogo.src;
    };
    const hasAtLeastOneImage = useMemo(()=>reviews === null || reviews === void 0 ? void 0 : reviews.reduce((result, review)=>result || hasCustomerImage(review), false), [
        reviews
    ]);
    return /*#__PURE__*/ _jsxs(StyledReviewsCarousel, {
        className: "reviews-carousel",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("reviews-carousel-content-and-indicators", {
                    "has-customer-image": hasAtLeastOneImage
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "reviews-carousel-content",
                        children: reviews.map((review, index)=>{
                            const { quote = "", name = "", jobDescription = "", companyLogo } = review;
                            return /*#__PURE__*/ _jsx("div", {
                                className: classnames("quote-wrapper", {
                                    selected: index === currentReviewIndex
                                }),
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "content-wrapper",
                                    children: [
                                        /*#__PURE__*/ _jsxs("blockquote", {
                                            className: "quote",
                                            id: `quote-${index}`,
                                            children: [
                                                !removeQuoteSigns && /*#__PURE__*/ _jsx("span", {
                                                    className: "quotationMark",
                                                    children: "“"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "quoteText",
                                                    children: `${removeQuoteSigns ? quote : `${quote}”`}`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "footer",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "name-and-job-description",
                                                    id: `reviewer-${index}-name-and-job-description`,
                                                    children: `${name} | ${jobDescription}`
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: classnames("logo", {
                                                        hidden: !hasCompanyLogo(review)
                                                    }),
                                                    children: hasCompanyLogo(review) && /*#__PURE__*/ _jsx(PictureComponent, _object_spread_props(_object_spread({}, companyLogo), {
                                                        height: "38px"
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "indicators",
                        children: reviews.map((review, indicatorIndex)=>/*#__PURE__*/ _jsx("div", {
                                className: INDICATOR_WRAPPER_CLASS_NAME,
                                onClick: (e)=>selectReview(indicatorIndex, e),
                                onKeyDown: generateOnKeyDownHandler(()=>selectReview(indicatorIndex)),
                                "aria-label": `review${indicatorIndex + 1}`,
                                "aria-describedby": `reviewer-${indicatorIndex}-name-and-job-description quote-${indicatorIndex}`,
                                "aria-current": indicatorIndex === currentReviewIndex,
                                role: "button",
                                tabIndex: 0,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: classnames("indicator", {
                                        selected: indicatorIndex === currentReviewIndex
                                    })
                                })
                            }, indicatorIndex))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("reviews-carousel-asset", {
                    hidden: !hasCustomerImage(reviews === null || reviews === void 0 ? void 0 : reviews[currentReviewIndex])
                }),
                children: hasCustomerImage(reviews === null || reviews === void 0 ? void 0 : reviews[currentReviewIndex]) && /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, reviews === null || reviews === void 0 ? void 0 : (_reviews_currentReviewIndex = reviews[currentReviewIndex]) === null || _reviews_currentReviewIndex === void 0 ? void 0 : _reviews_currentReviewIndex.customerImage))
            })
        ]
    });
};
export default ReviewsCarousel;
ReviewsCarousel.defaultProps = DefaultProps;
